// @todo: Migrate to 'Select' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Select} from '@wandb/weave/components/Form/Select';
import React, {type FC} from 'react';
import {type SingleValue} from 'react-select';

import {type UserAccountType} from '../../../generated/graphql';
import {type TeamMember} from '../../../types/graphql';
import {
  SingleUserInviteOptionComp,
  type UserInviteOption,
} from './UserInviteOptions';

interface ProjectOwnerOptionsProps {
  users: TeamMember[];
  selectedOwner: string;
  setSelectedOwner: (user: string) => void;
}

export const ProjectOwnerOptions: FC<ProjectOwnerOptionsProps> = ({
  users,
  selectedOwner,
  setSelectedOwner,
}) => {
  const options: UserInviteOption[] = users.map(u => {
    return {
      value: u.id as string,
      label: u.name,
      username: u.username,
      photoUrl: u.photoUrl,
      name: u.name,
      email: u.email,
      accountType: u.accountType as UserAccountType,
    };
  });

  const currentValue = options.filter(u => selectedOwner.includes(u.value));

  return (
    <Select<UserInviteOption>
      className={'w-full'}
      size={'variable'}
      value={currentValue}
      options={options}
      placeholder={'Select project owner'}
      closeMenuOnSelect={false}
      onChange={(opt: SingleValue<UserInviteOption>) => {
        if (opt?.value) {
          setSelectedOwner(opt.value);
        }
      }}
      components={{
        Option: SingleUserInviteOptionComp,
      }}
    />
  );
};
